import styled from "styled-components";

export const SelectItemsNoSearchResults = styled.div`
    text-align: center;
`;

export const SelectItemsListWrapper = styled.div`
    min-height: 100px;
`;